export const constRoute = {
  root: "/",
  masteradminLogin: "/login",
  masteradminDashboard: "/dashboard",
  masteradminUsers: "/users",
  masteradminPromptPanel: "/prompt-panel",
  masteradminResource: "/resource-center",
  masteradminBilling: "/billing",
  masteradminAppSettings: "/app-settings",
};
